import type { FirebaseOptions } from 'firebase/app';

const productionConfig: FirebaseOptions = {
  apiKey: 'AIzaSyBo5SJTYr4miT3IuYrJskxMiWUbYHqMFck',
  authDomain: 'amplio-backend.firebaseapp.com',
  projectId: 'amplio-backend',
  storageBucket: 'amplio-backend.appspot.com',
  messagingSenderId: '240082929369',
  appId: '1:240082929369:web:2b929da62b45e881e5e0c8',
  measurementId: 'G-E1L151MC7R',
};

// The staging project has a single registered web app, so the site shares its
// appId with the Tool there; in production the two are separate registrations
// (see libraries/firebase/firebase-config.ts).
const stagingConfig: FirebaseOptions = {
  apiKey: 'AIzaSyBZJpYIQkaOa81MVrVaxuIBKQKifXQL_zk',
  authDomain: 'amplio-backend-staging.firebaseapp.com',
  projectId: 'amplio-backend-staging',
  storageBucket: 'amplio-backend-staging.firebasestorage.app',
  messagingSenderId: '324382448118',
  appId: '1:324382448118:web:b5c92c2aea4d3b7c254fd7',
};

export const FIREBASE_ENVIRONMENTS = [ 'production', 'staging' ] as const;

export type FirebaseEnvironment = typeof FIREBASE_ENVIRONMENTS[number];

const configsByEnvironment: Record<FirebaseEnvironment, FirebaseOptions> = {
  production: productionConfig,
  staging: stagingConfig,
};

export function resolveFirebaseEnvironment(value: string | undefined): FirebaseEnvironment {
  if (value === undefined || value === '') return 'production';
  // A typo'd value must not fall back to production: the site would then be
  // built and deployed against the live backend while everything around it
  // said staging.
  if (!(FIREBASE_ENVIRONMENTS as readonly string[]).includes(value)) {
    throw new Error(
      `Unknown AMPLIO_FIREBASE_ENV "${value}" - expected one of ${FIREBASE_ENVIRONMENTS.join(', ')}`,
    );
  }
  return value as FirebaseEnvironment;
}

// gatsby-node's onCreateWebpackConfig replaces this expression with a string
// literal in the browser bundles, so the deployed site holds no runtime env
// read here and cannot be pointed at another backend after it is built.
export const firebaseEnvironment = resolveFirebaseEnvironment(process.env.AMPLIO_FIREBASE_ENV);

export const firebaseConfig: FirebaseOptions = configsByEnvironment[firebaseEnvironment];
